import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import RealityCheck from "components/Business/RealityCheck/RealityCheck";
import NextRealityCheck from "components/Next/RealityCheck/RealityCheck";
import NextRealityCheckContinuous from "components/Next/RealityCheck/RealityCheckContinuous";
import RealityCheckContinuous from "components/Business/RealityCheck/RealityCheckContinuous";

import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

const getIsActiveOverallSegment = (project, optimized) => {
  return (
    optimized &&
    optimized.activeSegment &&
    optimized.activeSegment.conditions.length === 0 &&
    optimized.activeSegment.job &&
    project &&
    project.segments &&
    project.segments.length > 1
  );
};

class RealityCheckContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    const { setup } = props;

    if (setup && !setup.pursuedRatio && !setup.notPursuedRatio) {
      const defaultRatio = (setup.truePositive / (setup.truePositive + setup.falsePositive)) * 100;
      props.updatePursuedRatio(defaultRatio);
      props.updateNotPursuedRatio(defaultRatio);
    }
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  render() {
    const {
      match,
      aibleViewType,
      isTableauMode,
      project,
      optimized,
      optimizer,
      isContinuous,
      segmentOptions,
      modelGroups,
      updateDrilldownValue,
      isNext
    } = this.props;

    if (isNext) {
      return <NextRealityCheck {...this.props} />;
    }

    return isContinuous ? <RealityCheckContinuous {...this.props} /> : <RealityCheck {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  const retId = ownProps.runId;

  return {
    updateTrueAction: (trueAction) => dispatch(setupReducer.updateTrueAction(retId, trueAction)),
    updateFalseAction: (falseAction) => dispatch(setupReducer.updateFalseAction(retId, falseAction)),
    updateOutcomeLabel: (outcomeLabel) => dispatch(setupReducer.updateOutcomeLabel(retId, outcomeLabel)),
    updateTransactionLabel: (transactionLabel) =>
      dispatch(setupReducer.updateTransactionLabel(retId, transactionLabel)),
    updateNotPursuedTransactionLabel: (notPursuedTransactionLabel) =>
      dispatch(setupReducer.updateNotPursuedTransactionLabel(retId, notPursuedTransactionLabel)),
    updateAdvancedRevenueLabel: (advRevenueLabel) =>
      dispatch(setupReducer.updateAdvancedRevenueLabel(retId, advRevenueLabel)),
    updateTruePositiveLabel: (truePositiveLabel) =>
      dispatch(setupReducer.updateTruePositiveLabel(retId, truePositiveLabel)),
    updateUnitType: (unitType) => dispatch(setupReducer.updateUnitType(retId, unitType)),

    updateMadLibs: (key, value) => dispatch(setupReducer.updateMadLibs(retId, key, value)),

    updatePursuedCount: (pursuedCount) => {
      dispatch(setupReducer.updatePursuedCount(retId, pursuedCount));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateNotPursuedCount: (notPursuedCount) => {
      dispatch(setupReducer.updateNotPursuedCount(retId, notPursuedCount));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updatePursuedRatio: (pursuedRatio) => {
      dispatch(setupReducer.updatePursuedRatio(retId, pursuedRatio));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id, true));
      }
    },
    updateNotPursuedRatio: (notPursuedRatio) => {
      dispatch(setupReducer.updateNotPursuedRatio(retId, notPursuedRatio));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id, true));
      }
    },

    updateTryRatio: (tryRatio) => {
      dispatch(setupReducer.updateTryRatio(retId, tryRatio));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id, true));
      }
    },

    updateConversionGain: (conversionGain) => {
      dispatch(setupReducer.updateConversionGain(retId, conversionGain, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateConversionCost: (conversionCost) => {
      dispatch(setupReducer.updateConversionCost(retId, conversionCost, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateConversionSaved: (conversionSaved) => {
      dispatch(setupReducer.updateConversionSaved(retId, conversionSaved, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },
    updateConversionMissed: (conversionMissed) => {
      dispatch(setupReducer.updateConversionMissed(retId, conversionMissed, undefined, undefined, ownProps.id));
      if (ownProps.id !== "new") {
        dispatch(projectReducer.resetBudget(ownProps.id));
      }
    },

    updateTotal: (total) => {
      dispatch(setupReducer.updateScaledTotal(ownProps.id, retId, total));
    },

    updateShowBusiness: (showBusiness) => dispatch(setupReducer.updateShowBusiness(retId, showBusiness)),
    updateShowImpact: (showImpact) => dispatch(setupReducer.updateShowImpact(retId, showImpact)),

    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    },

    updateBudgetRange: (budgetRange) => {
      dispatch(setupReducer.updateBudgetRange(retId, id, budgetRange));
    },

    updateCountType: (countType) => dispatch(setupReducer.updateCountType(retId, countType)),

    updateExpectedCountContinuous: (continuousCount) => {
      dispatch(setupReducer.updateIsRealityHammer(retId, true));
      dispatch(setupReducer.updateExpectedCountContinuous(retId, continuousCount));
    },
    updateExpectedValueContinuous: (continuousAveragePrice) => {
      dispatch(setupReducer.updateIsRealityHammer(retId, true));
      dispatch(setupReducer.updateExpectedValueContinuous(retId, continuousAveragePrice));
    },

    updateBaselineCountContinuous: (continuousCount) => {
      dispatch(setupReducer.updateBaselineCountContinuous(retId, continuousCount));
    },
    updateBaselineValueContinuous: (continuousAveragePrice) => {
      dispatch(setupReducer.updateBaselineValueContinuous(retId, continuousAveragePrice));
    },

    updateContinuousPercent: (continuousPercent) =>
      dispatch(setupReducer.updateContinuousPercent(retId, continuousPercent)),
    updateCurrentProfit: (currentProfit) => dispatch(setupReducer.updateCurrentProfit(retId, currentProfit)),

    updateTimePeriod: (timePeriod) => dispatch(setupReducer.updateTimePeriod(retId, timePeriod))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  const isEditBlueprint = businessReducer.getIsEditBlueprint(state, id);

  let optimized = ownProps.optimized;
  if (!optimized || Number(optimized.id) !== Number(id)) {
    optimized = projectReducer.getOptimized(state, id);
  }

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || modelGroups.id !== id) {
    modelGroups = projectReducer.getModelGroups(state, id);
  }

  const editBlueprintId = businessReducer.getEditBlueprintRunId(state, id);

  const runId = ownProps.runId
    ? ownProps.runId
    : isEditBlueprint
      ? editBlueprintId
      : optimized && optimized.innerId !== undefined
        ? optimized.innerId
        : id;

  const setup = setupReducer.getSetup(state, runId);

  const isOverallSegment = projectReducer.getIsOverallSegment(state, id, runId);

  return {
    runId: runId,
    isEditBlueprint: isEditBlueprint,

    isOverallSegment: isOverallSegment,

    optimizer: projectReducer.getOptimizer(state, id),
    optimized: optimized,
    project: projectReducer.getProject(state, id),
    isContinuous: setupReducer.getIsContinuous(state, runId),
    modelGroups: modelGroups,

    setup: setup,
    setupLabels: setupReducer.getSetupLabels(state, runId),

    timePeriod: setupReducer.getTimePeriod(state, runId),
    timePeriodSelection: setupReducer.getTimePeriodSelection(state, runId),

    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    unitType: setupReducer.getUnitType(state, runId),

    blueprint: setupReducer.getBlueprintFromSetup(state, runId),
    madLibs: setupReducer.getMadLibs(state, runId),
    dataset: setupReducer.getDatasetFromSetup(state, runId),
    outcomeWinRate: setupReducer.getOutcomeWinRate(state, runId),
    customMappings: setupReducer.getCustomMappings(state, runId),

    baselineCountContinuous: isOverallSegment
      ? projectReducer.getOverallContinuousCount(state, id)
      : setupReducer.getBaselineCountContinuous(state, runId),
    baselineValueContinuous: isOverallSegment
      ? projectReducer.getOverallContinuousValue(state, id)
      : setupReducer.getBaselineValueContinuous(state, runId),

    continuousPercent: setupReducer.getCurrentContinuousPercent(state, runId, id),
    continuousCurrentProfit: setupReducer.getCurrentContinuousProfit(state, runId, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RealityCheckContainer);
